<template>
	<div class="m-recommend">
		<ul class="tab-list flex">
			<li v-if="unitData.show == 1" class="flex-grow flex-column flex-center z-crt">
				<div>{{unitData.title_text}}</div>
				<p>{{unitData.sub_title}}</p>
			</li>
			<li v-for="(item, i) in unitData.tabs" :key="i" class="flex-grow flex-column flex-center">
				<div>{{item.title_text}}</div>
				<p>{{item.sub_title}}</p>
			</li>
		</ul>
		<div class="product-list flex-between">
			<ul>
				<template v-for="(item, i) in unitData.product_list">
					<li v-if="i % 2 == 0" :key="item.product_id">
						<sub-image class="image" :src="item.product_img_url" mode="widthFix"></sub-image>
						<div class="info">
							<p class="name ellipsis-2">{{item.product_name}}</p>
							<div class="price">￥{{item.sale_price}}</div>
						</div>
					</li>
				</template>
			</ul>
			<ul>
				<template v-for="(item, i) in unitData.product_list">
					<li v-if="i % 2 == 1" :key="item.product_id">
						<sub-image class="image" :src="item.product_img_url" mode="widthFix"></sub-image>
						<div class="info">
							<p class="name ellipsis-2">{{item.product_name}}</p>
							<div class="price">￥{{item.sale_price}}</div>
						</div>
					</li>
				</template>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-recommend {
		padding-bottom: 10px;
		background: #F2F2F2;
			
		.tab-list {
			height: 56px;
			background: #F2F2F2;
			
			li {
				height: 100%;
				
				&.z-crt {
					div, p {
						color: #C70000;
					}
				}
				
				div {
					font-size: 20px;
					font-weight: bold;
				}
				
				p {
					margin-top: 5px;
					font-size: 12px;
					color: #999;
				}
			}
		}
		
		.product-list {
			padding: 0 12px;
			
			ul {
				li {
					width: 169px;
					border-radius: 4px;
					overflow: hidden;
					background: #fff;
					
					&:nth-child(n+2) {
						margin-top: 13px;
					}
					
					.info {
						padding: 5px 11px 0;
						
						.name {
							line-height: 18px;
							font-size: 12px;
							color: #333;
						}
						
						.price {
							line-height: 35px;
							font-size: 15px;
							font-weight: bold;
						}
					}
				}
			}
		}
	}
</style>
